export default __webpack_public_path__ + "static/p4-c82f4bc56019d50c25bb630ac74bda4d.png";